module.exports = __webpack_public_path__ + "img/1723132578225-cookies.jpg.8f0753cb.webp";